import { Popover } from "@mui/material";
import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ChipWrapper = styled.div`
  .mui-chip-wrapper > div {
    padding: 5px 0px;
  }
`;

export const StyledChipPopover = styled(Popover)<{
  popoverWidth: number;
  minWidth?: number;
}>`
  .MuiPaper-root {
    border: 1px solid ${COLORS.cirrus_black5};
    padding: 4px;
    border-radius: 4px;
    margin-top: 8px;
    width: ${(props) => props.popoverWidth}px;
    ${(props) => (props.minWidth ? `min-width: ${props.minWidth}px;` : "")};
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.25);
  }

  .content {
    max-height: 200px;
    overflow: auto;
    padding: 0px;
    margin: 0px 0px 5px 0px;
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    margin: 0px 10px;
  }

  .text-title {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
  }

  .max-width {
    max-width: 250px;
    line-height: 27px;
  }

  .close-image {
    color: ${COLORS.primary_light_blue};
  }
`;
